import React from 'react'
import { radius, themeColors } from '../../constants'

// Small gold pill showing a book's settlement currency code, shared by the
// account-book list rows and the page headers so the style + alignment stay
// consistent. Vertically centers in both flex and inline contexts.
const CurrencyBadge = ({ currency, style }) => {
  const code = currency || 'TWD'

  return (
    <span style={{ ...baseStyle, ...(style || {}) }}>
      {code}
    </span>
  )
}

const baseStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  verticalAlign: 'middle',
  lineHeight: 1,
  fontSize: '11px',
  fontWeight: 600,
  color: themeColors.gold900,
  background: 'rgba(138, 84, 20, 0.16)',
  borderRadius: radius.sm,
  padding: '3px 7px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
}

export default CurrencyBadge
